module.exports = __webpack_public_path__ + "img/JUNIORLOGO.df31e0d6.png";